import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';

/* babel-plugin-inline-import '../../templates/header.html' */
var headerHtml = "\n  <label for=\"brg-tr\" class=\"brg-b\">\n    <div class=\"brg\">\n      <span class=\"brg-c\">\n        <span class=\"brg-c-i\"></span>\n      </span>\n      <span class=\"brg-t\"><span class=\"a11y--h\">Toggle </span>Menu</span>\n    </div>\n  </label>\n\n  <div class=\"lo lo--abs\">\n    <div class=\"lo-l\">\n      <a href=\"https://www.boston.gov/\" title=\"Home | Boston.gov\">\n        <img src=\"https://patterns.boston.gov/images/public/logo.svg\" alt=\"Home | Boston.gov\" class=\"lo-i\">\n      </a>\n      <span class=\"lo-t\"><a href=\"https://www.boston.gov/mayor\">Mayor Michelle Wu</a></span>\n    </div>\n  </div>\n  <a id=\"seal\" href=\"https://www.boston.gov/\" title=\"Home | Boston.gov\" rel=\"home\" class=\"s\">\n  <img src=\"https://patterns.boston.gov/images/public/seal.svg\" alt=\"Home | Boston.gov\" class=\"s-i\" />\n</a>\n\n<nav class=\"nv-h\">\n  <ul class=\"nv-h-l\">\n    <li class=\"nv-h-l-i\"><a href=\"https://www.boston.gov/pay-and-apply\" title=\"Pay and apply\" class=\"nv-h-l-a\">Pay and apply</a></li>\n    <li class=\"nv-h-l-i\"><a href=\"https://www.boston.gov/public-notices\" title=\"Public notices\" class=\"nv-h-l-a\">Public notices</a></li>\n    <li class=\"nv-h-l-i\"><a href=\"mailto:feedback@boston.gov\" title=\"Feedback\" class=\"nv-h-l-a\" onClick=\"document.getElementById(&quot;contactForm&quot;).show(); return false;\">Feedback</a></li>\n    <li class=\"tr nv-h-l-i\">\n      <a href=\"https://www.boston.gov/#translate\" title=\"Translate\" class=\"nv-h-l-a nv-h-l-a--k--s tr-link\">Translate</a>\n      <ul class=\"tr-dd\">\n        <li><span class=\"notranslate tr-dd-link tr-dd-link--message\">Loading...</span></li>\n        <li><a href=\"https://www.boston.gov/#\" class=\"notranslate tr-dd-link\" data-ln=\"ht\">Krey&#xF2;l Ayisyen</a></li>\n        <li><a href=\"https://www.boston.gov/#\" class=\"notranslate tr-dd-link\" data-ln=\"pt\">Portugese</a></li>\n        <li><a href=\"https://www.boston.gov/#\" class=\"notranslate tr-dd-link\" data-ln=\"es\">Espa&#xF1;ol</a></li>\n        <li><a href=\"https://www.boston.gov/#\" class=\"notranslate tr-dd-link\" data-ln=\"vi\">Ti&#x1EBF;ng Vi&#x1EC7;t</a></li>\n        <li><a href=\"https://www.boston.gov/#\" class=\"notranslate tr-dd-link tr-dd-link--hidden\" data-ln=\"en\">English</a></li>\n      </ul>\n    </li>\n    <li class=\"nv-h-l-i\">\n      <label for=\"s-tr\" title=\"Search\" class=\"nv-h-l-a nv-h-l-a--k nv-h-l-a-ic\" id=\"searchIcon\">\n        <svg id=\"Layer_2\" aria-label=\"Search\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 41\"><title>Search</title><path class=\"nv-h-l-a-i\" d=\"M24.2.6C15.8.6 9 7.4 9 15.8c0 3.7 1.4 7.2 3.6 9.8L1.2 37c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11.5-11.5C18 30 21 31 24.2 31c8.4 0 15.2-6.8 15.2-15.2C39.4 7.4 32.6.6 24.2.6zm0 26.5c-6.2 0-11.2-5-11.2-11.2S18 4.6 24.2 4.6s11.2 5 11.2 11.2-5 11.3-11.2 11.3z\"/></svg>\n      </label>\n    </li>\n  </ul>\n</nav>\n\n<div class=\"h-s\">\n  <form class=\"sf\" action=\"https://www.boston.gov/search\" accept-charset=\"UTF-8\" method=\"get\">\n    <input name=\"utf8\" type=\"hidden\" value=\"&#x2713;\">\n    <div class=\"sf-i\">\n      <input type=\"text\" name=\"query\" id=\"query\" value=\"\" placeholder=\"Search&#x2026;\" class=\"sf-i-f\" autocomplete=\"off\" aria-label=\"Search\">\n      <button class=\"sf-i-b\">Search</button>\n    </div>\n  </form>\n</div>\n  ";
/**
 * Common header element for City of Boston React applications.
 *
 * When the City Seal is visible in the header, it will slide up halfway out of
 * view when a user scrolls past ~310px. When the user has scrolled back to the
 * top of the document, the seal will slide back to its original position.
 */

export default function Header(props) {
  var className = 'h';

  if (props.className) {
    className = "".concat(className, " ").concat(props.className);
  }

  useEffect(function () {
    var timer;

    var handleScroll = function handleScroll() {
      if (timer) {
        window.clearTimeout(timer);
      } // Add or remove the CSS class once the user has stopped scrolling


      timer = window.setTimeout(function () {
        return handleScrollStop();
      }, 750);
    };

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  function handleScrollStop() {
    var sealElement = document.getElementById('seal');

    if (!isSealVisible()) {
      return;
    }

    if (sealElement) {
      if (window.scrollY > 310) {
        sealElement.classList.add('s--u');
      } else {
        sealElement.classList.remove('s--u');
      }
    }
  }

  return React.createElement(React.Fragment, null, React.createElement("input", {
    type: "checkbox",
    id: "s-tr",
    className: "s-tr",
    "aria-hidden": "true"
  }), React.createElement("header", _extends({
    role: "banner"
  }, props, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: headerHtml
    }
  })));
}
/**
 * The City Seal is only visible at the widest breakpoints, but always exists
 * in the DOM.
 */

function isSealVisible() {
  var sealElement = document.getElementById('seal');
  var sealElementDisplay = sealElement ? window.getComputedStyle(sealElement).getPropertyValue('display') : null;
  return !!(sealElement && sealElementDisplay !== 'none');
}